var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/component/device/bulk-action/index.pug
// module id = 451
// module chunks = 0